
import './App.css';
import Swap from './pages/Swap/Swap.jsx';
import About from './pages/About/About.jsx';
import Home from './pages/Home/Home.jsx';
import Contact from './pages/Contact/Contact.jsx';
import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
function App() {
  return (
      <BrowserRouter>
      <ScrollToTop/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path="/swap" element={<Swap/>}/>
        <Route path='/about' element={<About/>} />
        <Route path='/Contact' element={<Contact/>}/>
      </Routes>
    </BrowserRouter>
  );
}



function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


export default App;
